// Menu items, page titles and breadcrumbs are keyed by their English text; English needs no entries
// except keys containing a dot, which would otherwise warn as missing namespaced keys.
export default {
  en: {
    'Avg. Delivery Time': 'Avg. Delivery Time',
    'Personalkosten-Abgleich': 'Staff Cost Comparison',
  },
  de: {
    Home: 'Startseite',
    'Monthly Staff Overview': 'Personal-Monatsübersicht',
    'Delivery Date Dashboard': 'Liefertermin-Dashboard',
    'A-Products': 'A-Artikel',
    AI: 'KI',
    'Active/Inactive Products': 'Aktive/Inaktive Artikel',
    Activities: 'Aktivitäten',
    'All Scraped Items': 'Alle gescrapten Artikel',
    'Alternatives/Cross Selling': 'Alternativen/Cross-Selling',
    Analytics: 'Analysen',
    'Avg. Delivery Time': 'Ø Lieferzeit',
    Bookkeeping: 'Buchhaltung',
    'Brands Statistics': 'Markenstatistik',
    'Calculation Special Items': 'Kalkulation Sonderartikel',
    'Category Development': 'Kategorieentwicklung',
    'Category Statistics': 'Kategoriestatistik',
    'Conversion Rate': 'Konversionsrate',
    'Customer Support': 'Kundenservice',
    'Customers Analytics': 'Kundenanalyse',
    'Delayed Orders': 'Verspätete Bestellungen',
    'Email Report': 'E-Mail-Bericht',
    'Email Statistics': 'E-Mail-Statistik',
    'Fast/Slowmover Products': 'Schnell-/Langsamdreher',
    'Finance Report': 'Finanzbericht',
    Finance: 'Finanzen',
    'Freight Charges': 'Frachtkosten',
    Liquidity: 'Liquidität',
    'Marketplace Readiness': 'Marktplatzreife',
    'Month Report': 'Monatsbericht',
    'My Leads': 'Meine Leads',
    'Negotiation Opportunities': 'Verhandlungspotenziale',
    'New Articles H+H': 'Neue Artikel H+H',
    'Not Sold Products': 'Nicht verkaufte Artikel',
    'Open Offers': 'Offene Angebote',
    'Open Suppliers Orders': 'Offene Lieferantenbestellungen',
    'Order Frequency': 'Bestellhäufigkeit',
    'Orders Analytics': 'Auftragsanalyse',
    Orders: 'Aufträge',
    'Outdated Products': 'Veraltete Artikel',
    'Payment Settings': 'Zahlungseinstellungen',
    'Performance Overview': 'Performance-Übersicht',
    'Phone Report': 'Telefonbericht',
    'Phone Statistics': 'Telefonstatistik',
    'Plan Numbers': 'Planzahlen',
    'Price Adjustments': 'Preisanpassungen',
    'Price Calculation': 'Preiskalkulation',
    'Pricing Tool': 'Preistool',
    'Product ABC Analysis': 'ABC-Analyse Artikel',
    'Product Data Knowledge': 'Produktdaten-Wissen',
    'Product Data Pipeline': 'Produktdaten-Pipeline',
    'Product Data Progress': 'Produktdaten-Fortschritt',
    'Product Data Review': 'Produktdaten-Prüfung',
    'Product Management': 'Produktmanagement',
    'Product Sales Statistics': 'Artikel-Verkaufsstatistik',
    'Products Attributes': 'Artikelmerkmale',
    Products: 'Artikel',
    'Purchase Approvals': 'Einkaufsfreigaben',
    'Purchase Department': 'Einkauf',
    'Purchase Recommendations': 'Einkaufsempfehlungen',
    Reminders: 'Wiedervorlagen',
    'Revenue Margin': 'Umsatz & Marge',
    'Sales Board': 'Vertriebsboard',
    'Sales CRM': 'Vertriebs-CRM',
    'Sales Dashboard': 'Vertriebs-Dashboard',
    'Stock Value': 'Lagerwert',
    'Suppliers Orders': 'Lieferantenbestellungen',
    'Suppliers Statistics': 'Lieferantenstatistik',
    'Top Customers': 'Top-Kunden',
    'Updated Status Products': 'Artikel mit Statusänderung',
    'User Management': 'Benutzerverwaltung',
    'Vacation Tracking': 'Urlaubsverwaltung',
    'Vacation/Sickday Overview': 'Urlaubs-/Krankheitsübersicht',
    'Warehouse Statistics': 'Lagerstatistik',
  },
}
